<template>
  <a-config-provider :locale="locale">
    <transition name="fade-transform" mode="out-in">
      <div id="app">
        <router-view />
      </div>
    </transition>
  </a-config-provider>
</template>

<script>
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'

export default {
  data() {
    return {}
  },
  computed: {
    locale() {
      // 只是为了切换语言时，更新标题
      const { title } = this.$route.meta
      title && setDocumentTitle(`${i18nRender(title)} - ${domTitle}`)
      return this.$i18n.getLocaleMessage('zh-CN').antLocale
    },
  },
}
</script>
<style></style>
